// 取得當前網域
const currentDomain = window.domain_name || window.location.hostname;

// 預設名稱
let appName = process.env.REACT_APP_WEB_NAME || "DEMO";

// oneone 網域時顯示 The One
if (currentDomain.includes("oneone")) {
  appName = "TheOne";
} else if (currentDomain.includes("67vip")) {
  appName = "金宇";
}

export { appName };

export const rightSideConfig = {
  "/": "LobbyMenu",
  "/slots": "PlatformRight",
  "/live-casino": "PlatformRight",
  "/fish": "PlatformRight",
  "/arcade": "PlatformRight",
  "/block-chain": "PlatformRight",
  "/lottery": "PlatformRight",
  "/sports": "PlatformRight",
  "/bingo": "PlatformRight",
};
